import axios from 'axios';

export default {
  namespaced: true,
  
  state: {
    // Initialize with data from window if available, otherwise empty array
    data: window.getAllModulesAccessData || []
  },

  mutations: {
    /**
     * Set the modules access data
     * @param {Object} state - The Vuex state
     * @param {Array} data - The modules access data
     */
    setModulesAccessData(state, data) {
      state.data = data;
    }
  },

  actions: {
    /**
     * Fetch modules access data from the server
     * @param {Object} context - The Vuex context
     * @returns {Promise<Array>} The modules access data
     */
    async fetchModulesAccessData({ commit }) {
      try {
        const response = await axios.get('/modules-access-data');
        commit('setModulesAccessData', response.data);
        return response.data;
      } catch (error) {
        console.error('Error fetching modules access data:', error);
        throw error;
      }
    }
  },

  getters: {
    /**
     * Get all modules access data
     * @param {Object} state - The Vuex state
     * @returns {Array} All modules access data
     */
    allModulesAccessData: (state) => state.data,
    
    /**
     * Get a module by its slug
     * @param {Object} state - The Vuex state
     * @returns {Function} A function that takes a slug and returns the matching module or null
     */
    getModuleBySlug: (state) => (slug) => {
      if (!slug) return null;
      const moduleData = state.data.find(item => item?.module?.slug === slug);
      if (!moduleData) return null;
      
      // Return the module data with the suggested_plans properly mapped
      return {
        module: moduleData.module,
        has_access: moduleData.has_access,
        subscription_details: moduleData.subscription_details,
        suggested_plans: moduleData.suggested_plans || []
      };
    }
  }
};
